// @ts-nocheck
import {
  APPLY_OPPORTUNITY_FAIL,
  APPLY_OPPORTUNITY_REQUEST,
  APPLY_OPPORTUNITY_SUCCESS,
  CLEAR_CONTRACTOR_APPLIED_LIST,
  DECLINE_OPPORTUNITY_ANYWAY_FAILURE,
  DECLINE_OPPORTUNITY_ANYWAY_REQUEST,
  DECLINE_OPPORTUNITY_ANYWAY_SUCCESS,
  GET_ALL_OPPORTUNITIES_FAIL,
  GET_ALL_OPPORTUNITIES_REQUEST,
  GET_ALL_OPPORTUNITIES_SUCCESS,
  GET_APPLIED_OPPORTUNITIES_FAIL,
  GET_APPLIED_OPPORTUNITIES_REQUEST,
  GET_APPLIED_OPPORTUNITIES_SUCCESS,
  GET_CONTRACTOR_EVENTS_FAIL,
  GET_CONTRACTOR_EVENTS_REQUEST,
  GET_CONTRACTOR_EVENTS_SUCCESS,
  GET_CONTRACTOR_ISSUES_FAIL,
  GET_CONTRACTOR_ISSUES_REQUEST,
  GET_CONTRACTOR_ISSUES_SUCCESS,
  GET_NOT_RESPONDED_OPPORTUNITIES_FAIL,
  GET_NOT_RESPONDED_OPPORTUNITIES_REQUEST,
  GET_NOT_RESPONDED_OPPORTUNITIES_SUCCESS,
} from "../constants/opportunities";

const initialState = {
  opportunitiesNR: [],
  opportunitiesApp: [],
  opportunitiesAll: [],
  events: [],
  issues: [],
  allTotalPages: 0,
  allCurrentPage: 1,
  totalPages: 0,
  nrTotalPages: 0,
  nrCurrentPage: 1,
  appTotalPages: 0,
  appCurrentPage: 1,
  evnetTotalPages: 0,
  eventCurrentPage: 1,
  totalItems: null,
  currentPage: 1,
  totalEvents: null,
  isLoading: false,
  oppLoading: false,
  issueLoading: false,
  searchString: {
    notResponded: "",
    applied: "",
    event: "",
    allOpportunities: "",
  },
};

const opportunitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    // fetch opportunities applied
    case GET_APPLIED_OPPORTUNITIES_REQUEST:
      return {
        ...state,
        searchString: {
          ...state.searchString,
          applied: action.payload,
        },
        isLoading: true,
      };
    case GET_APPLIED_OPPORTUNITIES_SUCCESS:
      return {
        ...state,
        opportunitiesApp: action.payload?.data,
        appTotalPages: action.payload?.totalPages,
        totalItems: action.payload?.total,
        appCurrentPage: action.payload?.currentPage || state?.currentPage,
        isLoading: false,
      };
    case GET_APPLIED_OPPORTUNITIES_FAIL:
      return {
        ...state,
        isLoading: false,
      };

    // not responded opportunities
    case GET_NOT_RESPONDED_OPPORTUNITIES_REQUEST:
      return {
        ...state,
        searchString: {
          ...state.searchString,
          notResponded: action.payload,
        },
        isLoading: true,
      };
    case GET_NOT_RESPONDED_OPPORTUNITIES_SUCCESS:
      return {
        ...state,
        opportunitiesNR: action.payload?.data,
        nrTotalPages: action.payload?.totalPages,
        nrCurrentPage: action.payload?.currentPage,
        totalItems: action.payload?.total,
        isLoading: false,
      };
    case GET_NOT_RESPONDED_OPPORTUNITIES_FAIL:
      return {
        ...state,
        isLoading: false,
      };

    // get contractor issues
    case GET_CONTRACTOR_ISSUES_REQUEST:
      return {
        ...state,
        issueLoading: true,
      };
    case GET_CONTRACTOR_ISSUES_SUCCESS:
      return {
        ...state,
        issueLoading: false,
        issues: action.payload,
      };
    case GET_CONTRACTOR_ISSUES_FAIL:
      return {
        ...state,
        issueLoading: false,
      };

    // apply opportunity
    case APPLY_OPPORTUNITY_REQUEST:
      return {
        ...state,
        oppLoading: true,
      };
    case APPLY_OPPORTUNITY_SUCCESS:
      return {
        ...state,
        oppLoading: false,
      };
    case APPLY_OPPORTUNITY_FAIL:
      return {
        ...state,
        oppLoading: false,
      };

    // decline opportunity anyway
    case DECLINE_OPPORTUNITY_ANYWAY_REQUEST:
      return {
        ...state,
        oppLoading: true,
      };

    case DECLINE_OPPORTUNITY_ANYWAY_SUCCESS:
      return {
        ...state,
        oppLoading: false,
      };
    case DECLINE_OPPORTUNITY_ANYWAY_FAILURE:
      return {
        ...state,
        oppLoading: false,
      };

    // get contractor events
    case GET_CONTRACTOR_EVENTS_REQUEST:
      return {
        ...state,
        searchString: {
          ...state.searchString,
          event: action.payload,
        },
        isLoading: true,
      };
    case GET_CONTRACTOR_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload?.data,
        eventTotalPages: action?.payload?.totalPages,
        eventCurrentPage: action?.payload?.page,
        isLoading: false,
      };
    case GET_CONTRACTOR_EVENTS_FAIL:
      return {
        ...state,
        isLoading: false,
      };

    case GET_ALL_OPPORTUNITIES_REQUEST:
      return {
        ...state,
        searchString: {
          ...state.searchString,
          allOpportunities: action.payload,
        },
        isLoading: true,
      };

    case GET_ALL_OPPORTUNITIES_SUCCESS:
      return {
        ...state,
        opportunitiesAll: [...(action.payload?.data || [])],
        allTotalPages: action.payload?.totalPages,
        allCurrentPage: action.payload?.currentPage,
        isLoading: false,
      };

    case GET_ALL_OPPORTUNITIES_FAIL:
      return {
        ...state,
        isLoading: false,
      };

    // clear contractor applied list
    case CLEAR_CONTRACTOR_APPLIED_LIST:
      return {
        ...state,
        opportunitiesApp: [],
        appTotalPages: 0,
        appCurrentPage: 1,
      };

    default:
      return state;
  }
};

export default opportunitiesReducer;
export { initialState };